<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm07_ill#ill">List of Illustrations</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch00_fm08_ack#ack">Acknowledgments</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm10_int#int"><em>Introduction</em> · Money for Science</a></p>
<p class="toc2"><a class="nounder" href="#/xhtml/ch00_part1#part1"><strong>PART 1      COAL</strong></a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01#ch01"><em>Chapter 1</em> · Geological Enterprise</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch02#ch02"><em>Chapter 2</em> · The Strange Case of the Albert Mineral</a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><em>Chapter 3</em> · The American Sciences of Coal</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><em>Chapter 4</em> · Mining Science</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch04_part2#part2" title="Link target outside of Sample"><strong>PART 2      KEROSENE</strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><em>Chapter 5</em> · The Technological Science of Kerosene</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><em>Chapter 6</em> · The Kerosene Cases</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch06_part3#part3" title="Link target outside of Sample"><strong>PART 3      PETROLEUM</strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><em>Chapter 7</em> · The Rock Oil Report</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><em>Chapter 8</em> · The Elusive Nature of Oil and Its Markets</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><em>Chapter 9</em> · The Search for Oil and Oil-Finding Experts</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample"><em>Chapter 10</em> · California Crude</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11_Ebligue#epi" title="Link target outside of Sample"><em>Epilogue</em> · Americanization of Science</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12_notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch13_Essay#Essay" title="Link target outside of Sample">Essay on Sources</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch14_index#index" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_con.vue?ccf2875a